import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { ClassNameProp, TextView } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../translations';

type PhoneNumberTextViewProps = ClassNameProp & {
   readonly value: PhoneNumber | undefined;
};

export const PhoneNumberTextView = (props: PhoneNumberTextViewProps): JSX.Element => {
   return (
      <TextView
         label={practitionersTranslationKeys.modal.phoneNumber}
         testId={'phoneNumber'}
         className={props.className}
      >
         {props.value?.asString() ?? '-'}
      </TextView>
   );
};
